import React, {FC, useCallback, useEffect, useState} from 'react'
import {showErrorToast, showSuccessToast} from '../../../../shared/components/ToastUtils'
import {apiErrorMessage} from '../../public/PublicModels'
import {disconnectGoogle, getGoogleAuthUrl, getGoogleStatus, IGoogleStatus} from './Api'

/** Google hesabı bağlantı durumu; diğer ekranlar (mülakat) de kullanır */
export function useGoogleStatus() {
  const [status, setStatus] = useState<IGoogleStatus | null>(null)
  const reload = useCallback(() => {
    getGoogleStatus()
      .then(({data}) => setStatus(data.payload))
      .catch(() => setStatus({configured: false, connected: false}))
  }, [])
  useEffect(() => {
    reload()
  }, [reload])
  return {status, reload}
}

/** Kullanıcıyı Google onay sayfasına yönlendirir; dönüş /hr/google/callback */
export async function startGoogleConnect() {
  try {
    const {data} = await getGoogleAuthUrl()
    window.location.href = data.payload
  } catch (error) {
    showErrorToast(apiErrorMessage(error, 'Google bağlantısı başlatılamadı'))
  }
}

/** Takvim üstündeki Google Meet bağlantı kutusu */
export const GoogleConnectionBar: FC = () => {
  const {status, reload} = useGoogleStatus()

  if (!status) return null
  if (!status.configured) {
    return (
      <span className='text-muted fs-7'>
        <i className='bi bi-google me-1'></i>
        Google Meet entegrasyonu sunucuda ayarlı değil
      </span>
    )
  }

  const handleDisconnect = async () => {
    try {
      await disconnectGoogle()
      showSuccessToast('Google hesabı bağlantısı kaldırıldı')
      reload()
    } catch (error) {
      showErrorToast(apiErrorMessage(error, 'Bağlantı kaldırılamadı'))
    }
  }

  return status.connected ? (
    <div className='d-flex align-items-center gap-2'>
      <span className='badge badge-light-success py-2 px-3'>
        <i className='bi bi-google me-2 text-success'></i>
        {status.googleEmail}
      </span>
      <button type='button' className='btn btn-sm btn-light' onClick={handleDisconnect}>
        Bağlantıyı Kaldır
      </button>
    </div>
  ) : (
    <button type='button' className='btn btn-sm btn-light-primary' onClick={startGoogleConnect}>
      <i className='bi bi-google'></i>
      Google Hesabını Bağla (Meet)
    </button>
  )
}
